import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetUserProfileUpdatedAtQueryVariables = Types.Exact<{
  userId: Types.Scalars['bigint']['input'];
}>;


export type GetUserProfileUpdatedAtQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', updated_at: string } | null };


export const GetUserProfileUpdatedAtDocument = gql`
    query getUserProfileUpdatedAt($userId: bigint!) {
  users_by_pk(id: $userId) {
    updated_at
  }
}
    `;

/**
 * __useGetUserProfileUpdatedAtQuery__
 *
 * To run a query within a React component, call `useGetUserProfileUpdatedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileUpdatedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileUpdatedAtQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserProfileUpdatedAtQuery(baseOptions: Apollo.QueryHookOptions<GetUserProfileUpdatedAtQuery, GetUserProfileUpdatedAtQueryVariables> & ({ variables: GetUserProfileUpdatedAtQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileUpdatedAtQuery, GetUserProfileUpdatedAtQueryVariables>(GetUserProfileUpdatedAtDocument, options);
      }
export function useGetUserProfileUpdatedAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileUpdatedAtQuery, GetUserProfileUpdatedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileUpdatedAtQuery, GetUserProfileUpdatedAtQueryVariables>(GetUserProfileUpdatedAtDocument, options);
        }
// @ts-ignore
export function useGetUserProfileUpdatedAtSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserProfileUpdatedAtQuery, GetUserProfileUpdatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserProfileUpdatedAtQuery, GetUserProfileUpdatedAtQueryVariables>;
export function useGetUserProfileUpdatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserProfileUpdatedAtQuery, GetUserProfileUpdatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserProfileUpdatedAtQuery | undefined, GetUserProfileUpdatedAtQueryVariables>;
export function useGetUserProfileUpdatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserProfileUpdatedAtQuery, GetUserProfileUpdatedAtQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserProfileUpdatedAtQuery, GetUserProfileUpdatedAtQueryVariables>(GetUserProfileUpdatedAtDocument, options);
        }
export type GetUserProfileUpdatedAtQueryHookResult = ReturnType<typeof useGetUserProfileUpdatedAtQuery>;
export type GetUserProfileUpdatedAtLazyQueryHookResult = ReturnType<typeof useGetUserProfileUpdatedAtLazyQuery>;
export type GetUserProfileUpdatedAtSuspenseQueryHookResult = ReturnType<typeof useGetUserProfileUpdatedAtSuspenseQuery>;
export type GetUserProfileUpdatedAtQueryResult = Apollo.QueryResult<GetUserProfileUpdatedAtQuery, GetUserProfileUpdatedAtQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/auth/queries/getUserProfileUpdatedAt.query.gql}
 */
export async function getUserProfileUpdatedAt(
  variables: GetUserProfileUpdatedAtQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetUserProfileUpdatedAtQuery['users_by_pk']>
export async function getUserProfileUpdatedAt(
  variables: GetUserProfileUpdatedAtQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetUserProfileUpdatedAtQuery>
export async function getUserProfileUpdatedAt(
  variables: GetUserProfileUpdatedAtQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetUserProfileUpdatedAtQuery['users_by_pk'] | GetUserProfileUpdatedAtQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetUserProfileUpdatedAtQuery>(
    GetUserProfileUpdatedAtDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.users_by_pk
}